/**
 * api接口的统一出口
 */
// 汉高网站接口
import dongjuapi from './dongjuapi.js';
// 其他模块的接口……

// 导出接口
export default {
  dongjuapi,
}
